<template src="./SideMenuTitle.html"></template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        to: { type: String, required: false },
        title: { type: String, required: true }
    }
});
</script>

<style src="./SideMenuTitle.scss" lang="scss" scoped></style>
